module.exports = __webpack_public_path__ + "static/media/whoMLEWHre-164843-FISH-Deck-High-resize.c3364378.jpg";